import request from "libs/request"

// 查询列表
export function bannerFinds(data) {
  return request({
    url: '/banner/finds.do',
    headers: {
      locker: new Date().getTime()
    },
    method: 'POST',
    data: data
  })
}